var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"primary","block":""},on:{"click":_vm.reenviar_facturas}},[_vm._v(" Reenviar ventas ")])
}
var staticRenderFns = []

export { render, staticRenderFns }